<template>
  <div class="job-board-list">
    <data-table :service="JobBoardService"
                :entity="entity"
                :columns="columns"
                operations="edit,refresh"
                ref="table">
      <div slot="name" slot-scope="{row}" class="d-flex align-items-center">
        <base-avatar :src="row.logo" :name="row.name"></base-avatar>
        <span class="ml-3 text-default font-weight-bold">{{row.name}}</span>
      </div>
      <status-badge slot="status" slot-scope="{row}" :status="row.status"/>
      <template v-slot:host="{row}">
        <a v-if="getJobBoardUrl(row)"
           @click.stop=""
           :href="getJobBoardUrl(row)"
           class="flex items-center justify-start w-full"
           target="_blank" rel="noopener">
          <external-link-icon class="mr-1"></external-link-icon>
          <span class="pt-1">{{row.host}}</span>
        </a>
        <span v-else>- -</span>
      </template>
    </data-table>
  </div>
</template>
<script>
  import JobBoardService from 'src/services/JobBoardService';
  import entities from 'src/config/entities';
  import { ExternalLinkIcon } from 'vue-feather-icons'
  export default {
    name: 'job-board-list',
    components: {
      ExternalLinkIcon
    },
    data() {
      return {
        JobBoardService,
        entity: entities.JOB_BOARD
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('jobBoard.list.labels.name'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "status",
            label: this.$t('jobBoard.list.labels.status'),
            minWidth: "80px",
            sortable: true,
            align: "center"
          },
          {
            prop: "host",
            label: this.$t('jobBoard.list.labels.url'),
            minWidth: "150px",
            sortable: true,
            align: "center"
          }
        ]
      }
    },
    methods: {
      getJobBoardUrl(row) {
        let url = row.host
        let token = localStorage.getItem('token')
        return `https://${url}?layout=editor&token=${token}`
      }
    }
  }
</script>
<style lang="scss">
  .job-board-list {
    .url-cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
